document.addEventListener("DOMContentLoaded", () => {

  // AFTER CONTENT RENDERS LISTEN FOR BUNDLE ADDS
  document.addEventListener("load-complementary-products", () => {
    const variants = document.querySelectorAll('.td-product-add-button');

    variants.forEach((button) => {
      if (button) {
        button.addEventListener('click', (e) => {
          const productID = parseInt(button.dataset.productid);
          addItemToCart({ items: [{ id: productID, quantity: 1}], sections: getSectionsToRender().map((section) => section.section) });
        });
      }
    });
  });

  // ADD CART ITEM AJAX/LOGIC W/ SHOPIFY SECTION RENDERING API
  async function addItemToCart(product) {
    fetch(`${theme.routes.cart_add_url}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(product)
    })
    .then(response => {
      return response.json();
      })
    .then((response) => {
      dispatchCustomEvent('cart:item-added', {
        product: response.hasOwnProperty('items') ? response.items[0] : response
      });

      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
      renderContents(response);
    })
    .catch((err) => {
      console.log(err);
    });
  }

  // GET AND REPLCE OLD SECTIONS W/ NEW ONES
  function renderContents(parsedState) {
    getSectionsToRender().forEach((section => {
      // TD CHANGE - Update every cart count instance instead of only the first cart toggle target
      if (section.id === 'cart-drawer-toggle') {
        const cartBubbleHtml = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        document.querySelectorAll(section.selector).forEach((element) => {
          element.innerHTML = cartBubbleHtml;
        });
        return;
      }
      // END TD CHANGE

      if (!document.getElementById(section.id)) {
        return;
      }

      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }));
  }

  // CHECK IF ELEMENT HAS BEEN RENDERED
  const checkElement = async selector => {
    while ( document.querySelector(selector) === null) {
      await new Promise( resolve =>  requestAnimationFrame(resolve) );
    }
    return document.querySelector(selector);
  };

  // CHECK IF ELEMENT EXISTS AND TRIGGER EVENT
  checkElement('.td-product-cart-item').then((selector) => {
    document.dispatchEvent(new CustomEvent("load-complementary-products"));
  });

  // GET SECTION TEXT
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  // SETUP SECTIONS
  function getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
});
